module.exports = __webpack_public_path__ + "static/media/instagram.1255f0f8.svg";